import reducer from './reducers/index';
import routes from '../routes';
import * as jobOfferActions from './actions'
import * as jobOfferOperations from './operations'
import * as jobOfferSelectors from './selectors'

export {
    jobOfferActions,
    jobOfferOperations,
    jobOfferSelectors,
}

export default {
    routes,
    reducer,
}
